import React from "react";

export const ArticleCMYK = () => {
  return (
    <div className="article">
      <h2 className="article-headline">
        CMYK (Cyan, Magenta, Yellow, Black) - work in progress
      </h2>
      <p className="article.text"></p>
    </div>
  );
};
